import React, { useState } from "react";
import { Card, Tooltip } from "antd";
import JupyterhubLogo from "../images/JupyterhubLogo.png";
import MapLogo from "../images/MapLogo.png";
import './CardPageStyles.less';
import { ClipLoader } from 'react-spinners';
import JupyterHubServerModal from "./JupyterHubServerModal";

interface InsightEngineAppsProps {
    onExternalLinkClick: (url: string, e: React.MouseEvent<HTMLAnchorElement>) => void;
    deleteAllJupyterHubServers: () => Promise<string>;
    getActiveJupyterHubServerList: (server:string) => Promise<boolean>;
}

const InsightEngineApps: React.FC<InsightEngineAppsProps> = ({onExternalLinkClick, deleteAllJupyterHubServers, getActiveJupyterHubServerList}) => {

    const handleExternalLinkClick = (url: string, e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        onExternalLinkClick(url, e);
    };
    const [loading, setLoading] = useState(false);
    const [showexistingServerModal, setShowExistingServerModal] = useState(false);
    const handleOpenJupyterHub = async () => {
        setLoading(true);
        const same_server = await getActiveJupyterHubServerList("basic");
        if(same_server) {
            setLoading(false);
            setShowExistingServerModal(true);
        } else {
            try {
                const response = await deleteAllJupyterHubServers();
                if (response === 'All servers deleted successfully') {
                    setLoading(false);
                    window.open(process.env.REACT_APP_JUPYTERHUB_BASIC, '_blank');
                } else {
                    setLoading(false);
                    console.error("Failed to delete servers or error occurred");
                }
            } catch (error) {
                setLoading(false);
                console.error("Unexpected error occurred", error);
            } finally {
                setLoading(false);
            }
        }
    }

    const handleOpenMap = (e: any) => {
        // commenting the approach to open url in an iframe and opening in a new tab, as there are few security issues to be addressed.
        // handleExternalLinkClick(process.env.REACT_APP_MAP as string, e);
        window.open(process.env.REACT_APP_MAP, '_blank');
    }

    const handleOpenAllCards = (e: any) => {
        handleExternalLinkClick('ALL_CARDS', e) 
    }

    return (
        <div className="product-brief-intro">
            <div className="title-wrapper">
                <div className="crumbs">
                    <a href="#" onClick={handleOpenAllCards}>All Modules</a> &gt; Insight Engine
                </div><br />
                <div className="platform-title">Insight Engine</div><br />
                <div className="platform-subtitle">This platform provides a centralized environment for data analysis and visualization.</div>
                <span style={{ display: 'block', height: '20px' }} />
            </div>
            <div className="card-container">
                <Tooltip
                    title="A JupyterHub environment optimized for creating streamlined plots, conducting analyses, and running scripts in Python."
                    overlayInnerStyle={{color: 'black'}}
                    color="white"
                    placement="bottom"
                >
                    <Card 
                        className={loading ? "disabled app-card" : "app-card"}
                        hoverable
                        onClick={handleOpenJupyterHub}
                        cover={<img src={JupyterhubLogo} alt="jupyterhub-logo"/>}
                    >
                        {loading && (
                            <div className="spinner-overlay">
                                <ClipLoader color="#000" size={50} />
                            </div>
                        )}
                        <div>
                            <h2 className="title">
                                Explore
                            </h2>
                            <p className="subtitle">
                                Accelerate Your Python Explorations
                            </p>
                        </div>
                    </Card>
                </Tooltip>
                <Tooltip
                    title="A suite of analysis tools built to filter, analyze, and integrate multi-omics data."
                    overlayInnerStyle={{color: 'black'}}
                    color="white"
                    placement="bottom"
                >
                    <Card 
                        className="app-card"
                        hoverable
                        onClick={handleOpenMap}
                        cover={<img src={MapLogo} alt="open-map-logo"/>}
                    >
                        <div>
                            <h2 className="title">
                                MAP
                            </h2>
                            <p className="subtitle">
                                Multi-omics Analysis Portal
                            </p>
                        </div>
                    </Card>
                </Tooltip>
                {showexistingServerModal && (
                    <JupyterHubServerModal
                        isOpen={showexistingServerModal}
                        onClose={() => setShowExistingServerModal(false)}
                        onLaunch={() => {
                            setShowExistingServerModal(false);
                            window.open(process.env.REACT_APP_JUPYTERHUB_BASIC, '_blank');
                        }}
                    />
                )}
            </div>
        </div>
    );
};
  
export default InsightEngineApps;
  